const STORAGE_KEY = "contact.admin.uploadDebug";
type UploadDebugPreference = "1" | "0" | null;
let memoryPreference: UploadDebugPreference = null;

// Read once per page. If writes are blocked, an older stored value must not overwrite a new in-memory choice.
try {
	const stored = window.sessionStorage.getItem(STORAGE_KEY);
	memoryPreference = stored === "1" || stored === "0" ? stored : null;
} catch {
	console.warn("[Upload diagnostics] Admin session storage unavailable; preference lasts for this page only.");
}

/** Remember explicit on AND off values so the recorder's own session preference can be overridden. */
export function getUploadDebugPreference(): UploadDebugPreference {
	const requested = new URLSearchParams(window.location.search).get("uploadDebug");
	if (requested === "1" || requested === "0") {
		memoryPreference = requested;
		try {
			window.sessionStorage.setItem(STORAGE_KEY, requested);
		} catch {
			console.warn("[Upload diagnostics] Admin preference could not be saved for reloads.");
		}
	}
	return memoryPreference;
}

// Imported before the app/router: capture the entry URL before routing or authentication removes its query.
getUploadDebugPreference();
